{
  "opensInNewTab": " mở trong tab mới"
}
